module.exports = require("@material/radio/dist/mdc.radio");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/radio/dist/mdc.radio","commonjs2":"@material/radio/dist/mdc.radio","commonjs":"@material/radio/dist/mdc.radio","amd":"@material/radio/dist/mdc.radio","umd":"@material/radio/dist/mdc.radio"}
// module id = 43
// module chunks = 0